<h2><a [innerHtml]="details?.heading" [FCRouterLink]="getAllBrandsUrl()" id="fc-all-brands-header"></a></h2> 
<div class="fc-brand-summary" [innerHtml]="details?.summary"></div> 
<div class="fc-brand-row">
    <fc-brand-card *ngFor="let b of details?.brands" [brand]="b" [allBrandsUrl]="getAllBrandsUrl()" [category]="params.category"></fc-brand-card>
</div>
<div class="fc-brand-footer" *ngIf="details?.footer" [innerHtml]="details?.footer | markedInline"></div>
<div class="fc-brand-action" *ngIf="details?.footerAction">
    <a [innerHtml]="details?.footerAction" [FCRouterLink]="getAllBrandsUrl()" id="fc-all-brands-cta"></a>
</div>